import React from "react";
import { Card, CardContent } from "../ui/card";
import { Checkbox } from "../ui/checkbox";
import { Button } from "../ui/button";
import { CheckCircle2, XCircle, Image as ImageIcon } from "lucide-react";

import { Badge } from "../ui/badge";

const ScoreBoardActivityBlock = ({
  activity_data,
  activity_id,
  setBackDropInfo,
  verifyActivity,
  isAdmin,
}) => {
  const activity = activity_data?.find((a) => a.activity_id === activity_id);

  if (!activity) return null;

  return (
    <div className="space-y-2">
      {activity.dates?.map((dateItem, index) => (
        <Card key={index} className="mb-2">
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3 flex-1">
                <Checkbox
                  checked={dateItem.activity_completed}
                  disabled
                />
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <div className="font-medium">{new Date(dateItem.date).toLocaleDateString()}</div>
                    {dateItem.verified ? (
                      <Badge className="bg-green-500 hover:bg-green-600">Verified</Badge>
                    ) : (
                      <Badge variant="secondary">Unverified</Badge>
                    )}
                  </div>
                  <div className="text-sm text-gray-500">
                    Quantity: {dateItem.quantity || "N/A"}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                {dateItem.image && (
                  <Button
                    variant="outline"
                    size="icon"
                    onClick={() => setBackDropInfo({ open: true, data: dateItem.image })}
                  >
                    <ImageIcon className="h-4 w-4" />
                  </Button>
                )}
                {isAdmin && (
                  <div className="flex gap-1">
                    <Button
                      variant={dateItem.verified ? "default" : "outline"}
                      size="icon"
                      onClick={() => verifyActivity(activity_id, dateItem.date, true)}
                      className={dateItem.verified ? "bg-green-600 hover:bg-green-700" : "text-green-600 hover:text-green-700 hover:bg-green-50"}
                    >
                      <CheckCircle2 className="h-4 w-4" />
                    </Button>
                    <Button
                      variant={!dateItem.verified ? "default" : "outline"}
                      size="icon"
                      onClick={() => verifyActivity(activity_id, dateItem.date, false)}
                      className={!dateItem.verified ? "bg-red-600 hover:bg-red-700" : "text-red-600 hover:text-red-700 hover:bg-red-50"}
                    >
                      <XCircle className="h-4 w-4" />
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default ScoreBoardActivityBlock;
